import type { FC } from 'react'
import { useRef, useState } from 'react'
import { IconButton, Stack, TextField } from '@mui/material'
import SendRoundedIcon from '@mui/icons-material/SendRounded'
import { useFocusOnOpen } from '~/shared/hooks/useFocusOnOpen'

interface LuciComposerProps {
  open: boolean
  sendDisabled: boolean
  onSend: (question: string) => Promise<boolean>
}

export const LuciComposer: FC<LuciComposerProps> = ({ open, sendDisabled, onSend }) => {
  const [draft, setDraft] = useState('')
  const inputRef = useRef<HTMLTextAreaElement>(null)
  const question = draft.trim()

  useFocusOnOpen(inputRef, open)

  const submit = () => {
    if (question === '' || sendDisabled) return
    // Clear only the question that went, not text typed while it was in flight.
    void onSend(question).then(sent => {
      if (sent) setDraft(current => (current.trim() === question ? '' : current))
    })
  }

  return (
    <Stack direction="row" spacing={1} sx={{ px: 2, py: 1.5, alignItems: 'flex-end' }}>
      <TextField
        inputRef={inputRef}
        fullWidth
        multiline
        maxRows={5}
        size="small"
        label="Ask Luci about this member"
        value={draft}
        onChange={event => setDraft(event.target.value)}
        onKeyDown={event => {
          if (event.key !== 'Enter' || event.shiftKey) return
          event.preventDefault()
          submit()
        }}
      />
      <IconButton
        aria-label="Send"
        color="primary"
        disabled={sendDisabled || question === ''}
        onClick={submit}
      >
        <SendRoundedIcon />
      </IconButton>
    </Stack>
  )
}
